import React from 'react';
import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import classNames from 'classnames';
import { useTranslation } from 'services/localization/useTranslation';
import { AvailabilityStatusBubble } from 'components/AvailabilityStatusBubble';

interface Props {
	loading: boolean;
	hasProducts: boolean;
}
const TimeSlotListFooter = (props: Props) => {
	const classes = useStyles();
	const { loading, hasProducts } = props;
	const { t } = useTranslation();
	return (
		<Box className={classes.listFooter}>
			{!hasProducts ? (
				<Box p={1}>
					<Typography variant="body2" align="center">
						{t(
							'timeLocationSelector.addProductsToSeeEndTimes2',
							'Add some products to the order to see availabilities',
						)}
					</Typography>
				</Box>
			) : (
				<Box
					className={classNames(classes.legendItems, {
						[classes.legendItemsHidden]: loading,
					})}
				>
					<Box className={classes.legendItem}>
						<AvailabilityStatusBubble status="available" />
						<Typography variant="caption">
							{t('timeLocationSelector.available', 'Available')}
						</Typography>
					</Box>
					<Box className={classes.legendItem}>
						<AvailabilityStatusBubble status="unavailable" />
						<Typography variant="caption">
							{t('timeLocationSelector.notAvailable', 'Not available')}
						</Typography>
					</Box>
				</Box>
			)}
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		listFooter: {
			minHeight: '53px',
			borderTop: '1px solid rgba(0,0,0,0.22)',
			boxShadow: '0px -10px 30px 0px rgba(255,255,255,1)',
			position: 'relative',
			zIndex: 2,
			padding: theme.spacing(1),
		},
		legendItems: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
			flexWrap: 'wrap',
		},
		legendItemsHidden: {
			opacity: 0,
		},
		legendItem: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			padding: theme.spacing(1),
		},
	}),
);

export default TimeSlotListFooter;
